import React from 'react';
import PropTypes from 'prop-types';
import { TimelineLite } from 'gsap/TimelineLite';
import globals from '../globals';
import Heading from "../elements/Heading";
import PlainTextv2 from "./PlainTextv2";

class Terms extends React.Component {

	constructor(props) {
		super(props);

		this.items = [];
		this.svgs = [];
	}

	componentDidMount() {
		this.controller = globals.genericAnimation(this.content);
	}

	componentWillUnmount() {
		globals.destroy(this.controller);
	}

	handleClick(event, key) {
		event.preventDefault();
		let item = this.items[key];
		let svg = this.svgs[key];

		if (this.items[key].classList.contains('closed')) {
			this.animateOpen(item, svg);
		} else {
			this.animateClosed(item, svg);
		}
	}

	animateOpen(item, svg) {
		item.classList.remove('closed');
		item.classList.add('open');

		let tl = new TimelineLite(),
			content = item.querySelector('.content'),
			title = item.querySelector('.title');

		tl.set(content, {display: 'block', height: 'auto'});
		tl.from(content, 0.25, {height: 0});
		tl.to(svg, 0.2, {rotation: 0, transformOrigin: '50% 50%'}, 0);
		tl.to(title, 0.05, {paddingTop: '35px'}, 0);
		tl.to(item, 0.05, {paddingBottom: '20px'}, 0);
	}

	animateClosed(item, svg) {
		item.classList.remove('open');
		item.classList.add('closed');

		let tl = new TimelineLite(),
			content = item.querySelector('.content'),
			title = item.querySelector('.title');

		tl.to(content, 0.25, {height: 0});
		tl.set(content, {display: 'none', height: 'auto'});
		tl.to(svg, 0.2, {rotation: 90, transformOrigin: '50% 50%'}, 0);
		tl.to(title, 0.05, {paddingTop: '17px'}, 0);
		tl.to(item, 0.05, {paddingBottom: 0}, 0);
	}

	render() {
		const MyHeading = this.props.title ? <Heading title={this.props.title} /> : '';
		const Rows = this.props.data.map((item, key) => {
			return (
				<div key={key} className="item closed" ref={el => this.items[key] = el}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 34.02 34.02"
						className="toggle-icon"
						onClick={event => this.handleClick(event, key)}>
						<g id="Layer_2" data-name="Layer 2">
							<g id="Layer_1-2" data-name="Layer 1">
								<rect className="cls-1" y="12.76" width="34.02" height="8.5" rx="4.25" fill="#00d56a" />
								<rect className="cls-1" y="12.76" width="34.02" height="8.5" rx="4.25" fill="#00d56a" ref={el => this.svgs[key] = el}
									  transform="translate(0 34.02) rotate(-90)"/>
							</g>
						</g>
					</svg>
					<a href="#" className="title" onClick={event => this.handleClick(event, key)} dangerouslySetInnerHTML={{__html: globals.noWidows(item[0])}} />
					<div className="content">
						<PlainTextv2 data={item} excludeTitle={true} />
					</div>
				</div>
			);
		});

		return (
			<div className="row terms-module" id="terms">
				<div className="col-md-8 col-md-offset-2 col-xs-12 centered" ref={el => this.content = el}>
					{MyHeading}
					<div className="row mt-5 left-align">
						<div className="col-12">
							{Rows}
						</div>
					</div>
				</div>
			</div>
		);
	}

}

Terms.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	data: PropTypes.array.isRequired
};

export default Terms;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/Terms.js